import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=2069ff8a&scoped=true"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"
import style0 from "./adminLayout.vue?vue&type=style&index=0&id=2069ff8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069ff8a",
  null
  
)

export default component.exports